<template>
  <v-touch :class="['main', 'trigger'+this.ordem[pannel], 'trigger-'+this.$route.params.cat]" ref="home" :style="{'top': '-' + pannel * 100 + 'vh' }"
            @swipeup="onSwipeUp" @swipedown="onSwipeDown" @swiperight="onSwipeRight">
    <Capa />
    <Sobre />
    <Trabalhos />
    <Videos />
    <VideosTela />
    <Parceiros />
    <Contato />

    <Player />
  </v-touch>
</template>

<script>
// @ is an alias to /src
import Capa from '@/components/Capa.vue'
import Sobre from '@/components/Sobre.vue'
import Trabalhos from '@/components/Trabalhos.vue'
import Videos from '@/components/Videos.vue'
import VideosTela from '@/components/VideosTela.vue'
import Parceiros from '@/components/Parceiros.vue'
import Contato from '@/components/Contato.vue'

import Player from '@/components/Player.vue'

import _ from 'lodash'

export default {
  name: 'home',
  components: {
    Capa,
    Sobre,
    Trabalhos,
    Videos,
    VideosTela,
    Parceiros,
    Contato,
    Player
  },
  data() {
    return {
      ordem: [
        'Capa',
        'Sobre',
        'Trabalhos',
        'Parceiros',
        'Contato'
      ],
      counter: 0,
      direction: true,
      marker: true
    }
  },
  computed: {
    pannel() {
      if(this.$route.params.path) {
        return this.ordem.indexOf(this.$route.params.path) >= 0 ?
        this.ordem.indexOf(this.$route.params.path) : 0;
      } else { return 0; }
    }
  },
  methods: {
    onSwipeUp() {
      let next =  this.pannel < this.ordem.length - 1 ? this.pannel + 1 : this.pannel;
      this.$router.push({ name: 'home', params: { path: this.ordem[next] } });
    },
    onSwipeDown() {
      let last = this.pannel > 0 ? this.pannel - 1 : this.pannel;
      this.$router.push({ name: 'home', params: { path: this.ordem[last] } });
    },
    onSwipeRight() {
      if (this.$route.params.cat) {
         this.$router.push({ name: 'home', params: { path: this.$route.params.path } });
      }
    },
    onKey(e) {
      if(e.code == 'ArrowDown') {
        this.onSwipeUp();
      } else if(e.code == 'ArrowUp') {
        this.onSwipeDown();
      } else if(e.code == 'ArrowLeft') {
        this.onSwipeRight();
      }
    },
    onWheel: _.debounce(function(e) {
        if(e.deltaY > 0) {
          this.onSwipeUp();
        } else if(e.deltaY < 0) {
          this.onSwipeDown();
        } else if(e.deltaX < 0) {
          this.onSwipeRight();
        }
      }, 100, {leading:true, trailing:false})
  },
  created: function () {
      window.addEventListener("wheel", event => this.onWheel(event));
      window.addEventListener('keydown', event =>  this.onKey(event));
  },
  destroyed: function () {
      window.removeEventListener("wheel", event => this.onWheel(event));
      window.addEventListener('keydown', event =>  this.onKey(event));
  }
}
</script>
